import { createPullstateCore } from 'pullstate'

import { AppStore } from './appStore'

export const PullstateCore = createPullstateCore({
  AppStore,
})
